import { Component, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { DataService } from '../../../@core/services/data.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ContactFormInterface } from '../../../@core/models/site-material-data.model';
import { MatSnackBar } from '@angular/material/snack-bar';
import { GoogleAnalyticsService } from '../../../@core/services/google-analytics.service';
import { AnalyticsService } from '../../../@core/services/analytics.service';
import * as Sentry from "@sentry/browser";
import { SocialNetworksModel } from '../../../@core/models/social-networks.model';
import { BehaviorSubject, Subscription } from 'rxjs';
import { FontsService } from 'src/app/@core/services/fonts.service';


@Component({
  selector: 'app-contact-form',
  templateUrl: './contact-form.component.html',
  styleUrls: ['./contact-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MaterialContactFormComponent implements OnInit, OnDestroy {

  contactFormGroup: FormGroup;
  subscription: Subscription;
  title: string;
  titleSize: string;
  textSize: string;
  activatePadding: boolean = false;
  backgroundColor: string;
  textColor: string = '';
  titleColor: string = '';
  fontWeight: string = '';
  text: string;
  conversionLabel: string;
  // tslint:disable-next-line:max-line-length
  consentText = "By clicking the button bellow, you hereby acknowledge that we will process your personal information in accordance with our";
  buttonText: string = 'Get Started';
  mailChimpId: string;
  textAlign: string;
  errorMessage: string;
  email: string;
  phone: string;
  displayNetworks: boolean = false;
  data: ContactFormInterface;
  active: boolean = false;
  privacyPolicyExist: boolean = false;
  privacyPolicyLink: string = '';
  position: number = 0;
  moduleInfo: string;
  nameField: string;
  emailField: string;
  messageField: string;
  socialNetworks: SocialNetworksModel = {};
  loading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  loadingData$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  allElementAnimation: string;
  textAnimation: string;
  formAnimation: string;
  titleFontFamily: string;
  titleFontFamilyName: string;


  constructor(private dataService: DataService,private fontsService:FontsService, private analyticsService: AnalyticsService, private googleAnalyticsService: GoogleAnalyticsService, private _snackBar: MatSnackBar, private fb: FormBuilder) { }

  ngOnInit() {
    Sentry.configureScope(function (scope) {
      scope.setTag("component", "ContactFormComponent");
    });
    if (this.data.animation) {
      this.allElementAnimation = this.data.animation.allElement != '' ? this.data.animation.allElement : undefined;
      this.textAnimation = this.data.animation.text != '' ? this.data.animation.text : undefined;
      this.formAnimation = this.data.animation.form != '' ? this.data.animation.form : undefined;

    }
    this.loadingData$.next(true);
    this.moduleInfo = JSON.stringify({ position: this.position, new: false });
    this.initForm();
    this.title = this.data.title;
    this.titleSize = this.data.titleSize ? this.data.titleSize : '';
    this.textSize = this.data.textSize;
    this.fontWeight = this.data.fontWeight;
    this.textAlign = this.data.textAlign ? this.data.textAlign : '';
    this.text = this.data.text;
    this.nameField = this.data.nameField ? this.data.nameField : 'Your name';
    this.emailField = this.data.emailField ? this.data.emailField : 'Your email';
    this.messageField = this.data.messageField ? this.data.messageField : 'Your message';
    this.email = this.data.email ? this.data.email : '';
    this.phone = this.data.phone ? this.data.phone : '';
    this.displayNetworks = this.data ? (this.data.displayNetworks ? this.data.displayNetworks : false) : false;
    this.backgroundColor = this.data ? (this.data.backgroundColor ? this.data.backgroundColor : '') : '';
    this.titleColor = this.data.titleColor ? this.data.titleColor : this.data.textColor;
    this.textColor = this.data.textColor ? this.data.textColor : this.dataService.getDefaultColor(this.backgroundColor);
    this.titleFontFamily = this.data.titleFontFamily ? this.data.titleFontFamily : '';
    if(this.titleFontFamily){
      this.fontsService.AddFont(this.titleFontFamily);
      this.titleFontFamilyName = this.titleFontFamily.replace(/\+/g, " ")
    }
    if (this.data.consentText !== '' || this.data.consentText !== null) {
      this.consentText = this.data.consentText;
    }
    this.conversionLabel = this.data.conversionLabel;
    this.buttonText = this.data.buttonText;
    this.subscription = this.dataService.getCurrentSite().subscribe(site => {
      if (site) {
        this.privacyPolicyExist = site.privacyPolicy ? true : false;
        this.privacyPolicyLink = "https://" + (site.domainName ? site.domainName : site.siteUrl) + '/privacy-policy';

        if (this.displayNetworks) {
          if (site && site.socialMedia) {
            site.socialMedia.forEach(element => {
              if (element.link) {
                this.socialNetworks[element.network] = element.link;
              }
            });
          }
        }
      }
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  initForm(): void {
    this.contactFormGroup = this.fb.group({
      name: ['', Validators.required],
      email: ['', Validators.compose([
        Validators.email,
        Validators.required
      ])],
      message: ['', Validators.required],
      consent: [false] // ,Validators.required]
    });
  }

  isFormInvalid(): boolean {
    let invalid = [];
    const controls = this.contactFormGroup.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(name);
      }
    }
    if (controls['consent'].value === false && this.privacyPolicyExist) {
      this.errorMessage = 'Please read and agree to our privacy policy by checking the box.';
      return true;
    }
    else if (invalid.length <= 0) {
      return false;
    }
    else if (controls['consent'].value === true && this.contactFormGroup.valid) {
      this.errorMessage = undefined;
      return false;
    } else if (this.contactFormGroup.dirty && this.contactFormGroup.invalid) {
      this.errorMessage = 'Please fill in all the required fields.';
      return true;
    } else if (this.privacyPolicyExist && this.contactFormGroup.dirty && this.contactFormGroup.valid && controls['consent'].value === false) {
      this.errorMessage = 'Please read and agree to our privacy policy by checking the box.';
      return true;
    } else {
      return true;
    }
  }


  submitForm() {
    this.subscription = this.dataService.getCurrentSite().subscribe(site => {
      const body = {
        message: this.contactFormGroup.get('message').value,
        email: this.contactFormGroup.get('email').value,
        userName: this.contactFormGroup.get('name').value,
        subject: 'Contact message on ' + window.location.hostname,
        siteId: site.siteId,
        siteUrl: site.siteUrl,
        emailSiteOwner: site.email,
      };
      this.loading$.next(true);
      this.dataService.postcontactUs(body).subscribe(res => {
        this.initForm();
        this.loading$.next(false);
        const currentSite = this.dataService.site$.getValue();
        this._snackBar.open("Thanks for your interest. We'll get back to you soon!", '', {
          duration: 5000,
          verticalPosition: 'top',
          horizontalPosition: 'center',
          panelClass: ['info-snackbar']
        });
        if (currentSite) {
          this.analyticsService.trackConversion(currentSite, 'conversion');
        }
        if (currentSite.googleAnalyticsPixel) {
          this.googleAnalyticsService.eventEmitter('contact_us', 'contact_us', 'contact_us' + this.contactFormGroup.get('email').value, 'contact');
        }
        if (currentSite.facebookPixel) {
          this.googleAnalyticsService.FbEventEmitter('Contact', 'contact', 'Contact ', 'contact_us');
        }
        if (currentSite.googleAdwordsPixel && this.conversionLabel) {
          this.googleAnalyticsService.AdsEventEmitter(`${currentSite.googleAdwordsPixel.conversionID}/${this.conversionLabel}`, 'contact_us', 'contact_us');
        }
      }, err => {
        this.loading$.next(false);
        this._snackBar.open(err.error.message, '', {
          duration: 5 * 1000,
          verticalPosition: 'top',
          horizontalPosition: 'center',
          panelClass: ['danger-snackbar']
        });
      });
    });
  }
  setConsentChecked() {
    this.contactFormGroup.controls['consent'].setValue(!this.contactFormGroup.controls['consent'].value);
  }
  isSocialMediaExist() {
    if (!this.socialNetworks.facebook && !this.socialNetworks.instagram && !this.socialNetworks.linkedin && !this.socialNetworks.pinterest && !this.socialNetworks.snapchat && !this.socialNetworks.twitter && !this.socialNetworks.vkontakte && !this.socialNetworks.youtube) {
      return false;
    } else {
      return true;
    }
  }
}
